import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { ClinicsService } from 'src/app/core/services/clinics.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { documentsStringFormatter, phoneNumberStringFormatter } from 'src/app/core/utils/string-formatters';
import { ListTemplate } from 'src/app/shared/models/list-template';
import {Title} from "@angular/platform-browser";
import {Observable} from "rxjs";
import {ListModel} from "../../../../../core/models/list.model";

@Component({
  selector: 'app-professionals-list',
  templateUrl: './professionals-list.component.html',
  styleUrls: ['./professionals-list.component.scss']
})
export class ProfessionalsListComponent implements OnInit {

  searchString: string = "";
  orderingItem: string = "name";
  isClinicStaff = JSON.parse(localStorage.getItem('isClinicStaff')!);
  userAccessClinicId = JSON.parse(localStorage.getItem('userAccessClinicId')!);

  get canNewData() {
    const permissions = [PermissionConst.add_professional, PermissionConst.change_professional, PermissionConst.view_professional];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get canExport() {
    const permissions = [PermissionConst.export_professional, PermissionConst.change_professional, PermissionConst.view_professional];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  listTemplate: ListTemplate = {
    loading: true,
    showSearch: true,
    searchBarPlaceholder: "Buscar por Nome ou CPF",
    showAdvancedSearch: false,
    newDataText: "+ Novo Profissional",
    newDataRouterLink: this.canNewData ? "register" : undefined,
    notFoundMessage: "Nenhum profissional encontrado",
    header: [
      { name: "name", label: "Nome", widthInPercentage: "40%", width: "350px" },
      { name: "document_number", label: "CPNJ/CPF", widthInPercentage: "30%", width: "150px", displayStringConvertionFunction: documentsStringFormatter },
      { name: "phone_numbers", label: "Telefone", widthInPercentage: "30%", width: "250px", displayStringConvertionFunction: phoneNumberStringFormatter }],
    onHeaderItemClick: (value: string) => {
      let invertString = '';
      if (this.orderingItem == value) {
        this.listTemplate.invertedOrdering = !this.listTemplate.invertedOrdering;
        if (this.listTemplate.invertedOrdering)
          invertString = '-';
      }
      this.fetchList(this.searchString, `${invertString}${value}`, this.listTemplate.is_active);
      this.orderingItem = value;
      this.listTemplate.selectedOrdering = value;
    },
    onSearchFocusOut: (value: string) => {
      this.searchString = value;
      this.fetchList(value, this.orderingItem, this.listTemplate.is_active);
    },
    onClickActive: () => {
      this.listTemplate.is_active = !this.listTemplate.is_active;
      this.fetchList(this.searchString, this.orderingItem, this.listTemplate.is_active);
    },
    selectedOrdering: this.orderingItem,
    invertedOrdering: false,
    exportUrl: this.canExport ? '/professionals/export' : undefined,
    exportOptions: {
      id: 'ID',
      phone_numbers: 'Telefones',
      name: 'Nome',
      display_name: 'Nome de tratamento',
      gender: 'Gênero',
      birthdate: 'Data de nascimento',
      email: 'E-mail',
      document_number: 'CPF',
      cro: 'CRO',
      tags: 'Tags',
      specialties: 'Áreas de atuação'
    }
  };

  constructor(private clinicsService: ClinicsService, private sessionManager: SessionManagerService,
              private titleService: Title) {
    this.titleService.setTitle('ELEVE - Profissionais');
  }

  ngOnInit(): void {
    this.initializeList();
  }

  initializeList() {
    this.fetchList("", "name", this.listTemplate.is_active);
  }

  fetchProfessional(searchString: string, orderingItem: string, isActive: boolean | undefined, page: number = 1): Observable<ListModel> {
    if (this.isClinicStaff) {
      return this.clinicsService.professionalsList(searchString, orderingItem, isActive, page)
    }
    return this.clinicsService.professionalsListByClinic(this.userAccessClinicId, searchString, orderingItem, isActive, page)
  }

  fetchList(searchString: string, orderingItem: string, isActive: boolean | undefined) {
    this.listTemplate.loading = true;
    this.listTemplate.data = undefined;

    this.fetchProfessional(searchString, orderingItem, isActive).subscribe(response => {
      this.listTemplate.loading = false;
      this.listTemplate.data = response;
      this.listTemplate.hasNext = response.next != null;
    }, error => {
      const response = error as HttpErrorResponse;
      this.listTemplate.loading = false;
      this.listTemplate.error = true;
      this.listTemplate.errorMessage = response.error['detail'];
    });
  }

  loadMore(page: number) {
    this.listTemplate.loadingNext = true;
    this.fetchProfessional(this.searchString, this.orderingItem, this.listTemplate.is_active, page).subscribe(
      response => {
        this.listTemplate.hasNext = response.next != null;
        response.results!.map(item => this.listTemplate.data!.results!.push(item));
        this.listTemplate.loadingNext = false;
      },
      error => {
        const response = error as HttpErrorResponse;
        this.listTemplate.loading = false;
        this.listTemplate.error = true;
        this.listTemplate.errorMessage = response.error['detail'];
      });
  }
}
